import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Layout",
    redirect: "/knowledgeBase",
    component: () =>
      import(/* webpackChunkName: "KBLayout" */ "@/views/KBLayout.vue"),
    children: [
      // KnowledgeBaseindex.vue
      {
        path: "knowledgeBase",
        name: "KnowledgeBase",
        redirect: "/knowledgeBase/home",
        meta: {
          navIndex: 0,
        },

        component: () =>
          import(/* webpackChunkName: "layout" */ "@/views/KBPlatform/Layout"),

        children: [
          {
            path: "home",
            name: "Home",
            meta: {
              navIndex: 0,
            },
            component: () =>
              import(
                /* webpackChunkName: "home" */ "@/views/KBPlatform/HomePage"
              ),
          },
          // 文件夹
          {
            path: "category/:categoryName",
            name: "Category",
            meta: {
              navIndex: 0,
            },
            component: () =>
              import(
                /* webpackChunkName: "category" */ "@/views/KBPlatform/CategoryPage"
              ),
          },
          // 文章
          {
            path: "article/:articleName",
            name: "Article",
            meta: {
              navIndex: 0,
            },
            component: () =>
              import(
                /* webpackChunkName: "article" */ "@/views/KBPlatform/ArticlePage"
              ),
          },
          // 关联页
          {
            path: "associatedPage/:associatedName",
            name: "AssociatedPage",
            meta: {
              navIndex: 0,
            },
            component: () =>
              import(
                /* webpackChunkName: "artcle" */ "@/views/KBPlatform/AssociatedPage"
              ),
          },
          // 考试页
          {
            path: "/trainingExam/:articleName",
            name: "TrainingExam",
            meta: {
              navIndex: 0,
            },
            component: () =>
              import(
                /* webpackChunkName: "TrainingExam" */ "@/views/KBPlatform/TrainingExamPage/TrainingExam.vue"
              ),
          },
        ],
      },
      // 培训系统
      {
        path: "newTrainingSystem",
        name: "NewTrainingSystem",
        redirect: "/newTrainingSystem/home",
        meta: {
          navIndex: 1,
        },
        component: () =>
          import(
            /* webpackChunkName: "NewTrainingSystem" */ "@/views/KBTraining"
          ),
        children: [
          {
            path: "home",
            name: "NewTrainingHome",
            meta: {
              navIndex: 1,
            },
            component: () =>
              import(
                /* webpackChunkName: "NewTrainingHome" */ "@/views/KBTraining/Pages/home.vue"
              ),
          },
          {
            path: "training",
            name: "TrainingPlan",
            meta: {
              navIndex: 1,
            },
            component: () =>
              import(
                /* webpackChunkName: "TrainingPlan" */ "@/views/KBTraining/Pages/training.vue"
              ),
          },
          {
            path: "course",
            name: "TrainingCourse",
            meta: {
              navIndex: 1,
            },
            component: () =>
              import("@/views/KBTraining/components/Pages/Course.vue"),
            children: [
              {
                path: "",
                redirect: (to) => ({
                  name: "Training",
                  query: to.query,
                }),
              },
              {
                path: "training",
                name: "Training",
                meta: {
                  navIndex: 1,
                },
                component: () =>
                  import("@/views/KBTraining/Pages/training.vue"),
              },
            ],
          },

          {
            path: "editorHome",
            name: "EditorHome",
            meta: {
              navIndex: 1,
            },
            component: () => import("@/views/KBTraining/Pages/editorHome.vue"),
            beforeEnter(to, from, next) {
              const userData = JSON.parse(
                localStorage.getItem("User_Data") || "{}"
              );
              const roleIdList = userData.roleIdList || [];
              const allowed =
                roleIdList.includes(25) ||
                roleIdList.includes(1000022) ||
                roleIdList.includes(1000056);
              if (allowed) {
                next();
              } else {
                next({ name: "NewTrainingHome" });
              }
            },
          },
        ],
      },

      // Camp Schedule
      {
        path: "campSchedule",
        name: "CampSchedule",
        redirect: "campSchedule/home",
        meta: {
          navIndex: 2,
        },
        component: () =>
          import(/* webpackChunkName: "CampSchedule" */ "@/views/CampSchedule"),
        children: [
          {
            path: "home",
            name: "ScheduleHome",
            meta: {
              navIndex: 2,
            },
            component: () =>
              import(
                /* webpackChunkName: "ScheduleHome" */ "@/views/CampSchedule/ScheduleHome"
              ),
          },
          {
            path: "list",
            name: "ScheduleList",
            meta: {
              navIndex: 2,
            },
            component: () =>
              import(
                /* webpackChunkName: "ScheduleList" */ "@/views/CampSchedule/ScheduleList"
              ),
          },
          {
            path: "add",
            name: "AddSchedule",
            meta: {
              navIndex: 2,
            },
            component: () =>
              import(
                /* webpackChunkName: "AddSchedule" */ "@/views/CampSchedule/AddSchedule"
              ),
          },
          {
            path: "edit",
            name: "EditSchedule",
            meta: {
              navIndex: 2,
            },
            component: () =>
              import(
                /* webpackChunkName: "EditSchedule" */ "@/views/CampSchedule/EditSchedule"
              ),
          },
          {
            path: "preview/:id/:share",
            meta: {
              navIndex: 2,
            },
            name: "PreviewSchedule",
            component: () =>
              import(
                /* webpackChunkName: "PreviewSchedule" */ "@/views/CampSchedule/PreviewSchedule"
              ),
          },
        ],
      },

      // 云盘
      {
        path: "cloudStorage",
        name: "CloudStorageHome",
        redirect: "cloudStorage/All",
        meta: {
          navIndex: 3,
        },
        component: () =>
          import(
            /* webpackChunkName: "CloudStorage" */ "@/views/KBCloudStorage"
          ),
        children: [
          {
            path: "search/:keyword",
            name: "YunSearch",
            meta: {
              navIndex: 3,
            },
            component: () =>
              import(
                /* webpackChunkName: "YunSearch" */ "@/views/KBCloudStorage/CDSearch"
              ),
          },
          {
            path: ":folder",
            name: "CloudStorage",
            meta: {
              navIndex: 3,
            },
            component: () =>
              import(
                /* webpackChunkName: "CloudStorage" */ "@/views/KBCloudStorage/CDContent"
              ),
          },
        ],
      },

      // PPT Builder
      {
        path: "pptBuilder",
        name: "PPTBuilder",
        redirect: "pptBuilder/home",
        meta: {
          navIndex: 4,
        },
        component: () =>
          import(/* webpackChunkName: "PPTBuilder" */ "@/views/PPTBuilder"),
        children: [
          {
            path: "home",
            name: "PPTBuilderHome",
            meta: {
              navIndex: 4,
            },
            component: () =>
              import(
                /* webpackChunkName: "PPTBuilderHome" */ "@/views/PPTBuilder/homePage"
              ),
          },
          {
            path: "editor/:templateType/:templateId",
            name: "PPTBuilderEditor",
            meta: {
              navIndex: 4,
            },
            component: () =>
              import(
                /* webpackChunkName: "PPTBuilderEditor" */ "@/views/PPTBuilder/editorPage"
              ),
          },
          {
            path: "preview-page/:templateType/:secureId",
            name: "PPTBuilderPreviewPage",
            meta: {
              navIndex: 4,
            },
            component: () =>
              import(
                /* webpackChunkName: "PPTBuilderPreviewPage" */ "@/views/PPTBuilder/previewPage"
              ),
          },
          {
            path: "manage-page",
            name: "PPTBuilderManagePage",
            meta: {
              navIndex: 4,
            },
            component: () =>
              import(
                /* webpackChunkName: "ManageSaved" */ "@/views/PPTBuilder/manageSaved"
              ),
          },
          {
            path: "editorSavedPage/:id",
            name: "PPTBuilderEditorSaved",
            meta: {
              navIndex: 4,
            },
            component: () =>
              import(
                /* webpackChunkName: "PPTBuilderEditor" */ "@/views/PPTBuilder/editSavedPage"
              ),
          },
        ],
      },
    ],
  },
  {
    path: "/print",
    name: "Print",

    component: () =>
      import(/* webpackChunkName: "article" */ "@/views/KBPrint"),
  },
  {
    path: "/ppt-print",
    name: "PPTBuilderPrintPage",
    component: () =>
      import(
        /* webpackChunkName: "PPTBuilderPrintPage" */ "@/views/PPTBuilder/printPage"
      ),
  },
  {
    path: "/printtest",
    name: "PrintTest",

    component: () =>
      import(/* webpackChunkName: "article" */ "@/views/KBPrint/indextest.vue"),
  },
  {
    path: "/add",
    name: "Add",
    redirect: "/add/category",

    component: () => import(/* webpackChunkName: "add" */ "@/views/KBCreate"),
    children: [
      {
        path: "category",
        name: "AddCategory",
        component: () =>
          import(
            /* webpackChunkName: "AddCategory" */ "@/views/KBCreate/AddCategory"
          ),
      },
      {
        path: "article",
        name: "AddArticle",
        component: () =>
          import(
            /* webpackChunkName: "AddArticle" */ "@/views/KBCreate/AddArticle"
          ),
      },
    ],
  },
  {
    path: "/Edit",
    name: "Edit",
    redirect: "/edit/category",

    component: () => import(/* webpackChunkName: "edit" */ "@/views/KBEdit"),
    children: [
      {
        path: "category",
        name: "EditCategory",
        component: () =>
          import(
            /* webpackChunkName: "EditCategory" */ "@/views/KBEdit/EditCategory"
          ),
      },
      {
        path: "article",
        name: "EditArticle",
        component: () =>
          import(
            /* webpackChunkName: "EditArticle" */ "@/views/KBEdit/EditArticle"
          ),
      },
    ],
  },
  {
    path: "/search/keyword=:keyword",
    name: "Search",

    component: () =>
      import(/* webpackChunkName: "search" */ "@/views/KBSearch"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import(/* webpackChunkName: "Login" */ "@/views/Login"),
  },
  {
    path: "/share/:urlName",
    name: "SharePage",
    component: () =>
      import(/* webpackChunkName: "SharePage" */ "@/views/KBShare"),
  },
  {
    path: "/history",
    name: "HistoryPage",
    component: () =>
      import(/* webpackChunkName: "HistoryPage" */ "@/views/KBHistory"),
  },

  {
    path: "/v/:urlName/:id/:sId/:dId",
    name: "MiddlePage",
    component: () =>
      import(/* webpackChunkName: "SharePage" */ "@/views/KBShare/MiddlePage"),
  },
  {
    path: "ncJump",
    name: "MiddleKbPage",
    component: () =>
      import(
        /* webpackChunkName: "MiddleKbPage" */ "@/views/KBShare/MiddleKbPage.vue"
      ),
  },
  {
    path: "crmJump",
    name: "CRMJumpPage",
    component: () =>
      import(
        /* webpackChunkName: "CRMJumpPage" */ "@/views/KBShare/CRMJumpPage"
      ),
  },
  {
    path: "ncJump",
    name: "NCJumpPage",
    component: () =>
      import(
        /* webpackChunkName: "CRMJumpPage" */ "@/views/KBShare/NCJumpPage.vue"
      ),
  },
  {
    path: "/yun/:code",
    name: "CloudPathShareable",
    component: () =>
      import(
        /* webpackChunkName: "CloudPath" */ "@/views/KBShare/CloudFilePreview.vue"
      ),
  },
  {
    path: "/yun/:code/:file",
    name: "CloudPath",
    component: () =>
      import(
        /* webpackChunkName: "CloudPath" */ "@/views/KBShare/CloudFilePreview.vue"
      ),
  },
  {
    path: "/examEdit",
    name: "ArticleExamUpdate",
    component: () =>
      import(
        /* webpackChunkName: "ArticleExamUpdate" */ "@/views/KBManagement/ArticleExamUpdate"
      ),
  },

  {
    path: "*",
    component: () => import(/* webpackChunkName: "all" */ "@/views/404"),
  },
];

const router = new VueRouter({
  routes,
  mode: "history",
  base: process.env.BASE_URL,
  // base: '/usr/dev/Knowledge-base/',
});

export default router;
